import createInstance from "./interceptors";

const API_URL = process.env.VUE_APP_API_BASE_URL + "/api";

class LicenseService {
  // Método para obter todos os usuários
  getAllUsers() {
    const instance = createInstance();

    return instance.get(API_URL + "/license/users").then((response) => {
      return response.data;
    });
  }

  getCids() {
    const instance = createInstance();

    return instance.get(API_URL + "/license/cids").then((response) => {
      return response.data;
    });
  }
  postCreateLicense(data) {
    const instance = createInstance({
      responseType: "blob",
      "Content-Type": "multipart/form-data",
    });

    return instance
      .post(API_URL + "/license/create", data)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.error("Erro na requisição:", error);
        throw error; // Rejeita a promise para que o erro seja tratado no bloco catch de quem chama
      });
  }

  getTypes() {
    const instance = createInstance();

    return instance.get(API_URL + "/license/types").then((response) => {
      return response.data;
    });
  }

  getLicenseById(id) {
    const instance = createInstance();

    return instance.get(API_URL + "/license/" + id).then((response) => {
      return response.data;
    });
  }

  updateLicenseById(id, data) {
    const instance = createInstance();

    return instance
      .post(API_URL + "/license/update/" + id, data)
      .then((response) => {
        return response.data;
      });
  }
}

export default new LicenseService();
